import React from 'react';
import './PlayButton.css';
import './AllButtons.css';

export default function PlayButton(props) {
    function handleClick () {
      props.shufflePlayers();
      props.togglePlay();
    }
    return (
    <>
    <button className="Button PlayButton" onClick={handleClick}>Play!</button>
    </>
  )
}
